import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, UntypedFormBuilder} from '@angular/forms';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe, formatDate} from '@angular/common';
import {UserService} from 'src/app/services/user/user.service';
import {ShipmentReviewService} from 'src/app/services/shipment-review/shipment-review.service';
import {takeWhile} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import {ColDef, ColGroupDef, GridOptions} from "ag-grid-enterprise";
import {FrtOtoRateQueryService} from "../../services/frt-oto-rate-query/frt-oto-rate-query.service";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {
  ConfirmationModalComponent
} from "../../shared/common-components/confirmation-modal/confirmation-modal.component";
import {
  agency_admin_role,
  agency_auditor_role, agency_user, BusinessType,
  carrier_user,
  carrier_user_admin,
  system_admin
} from "../../shared/common-components/AppConstants";

@Component({
    selector: 'app-frt-oto-bids-review',
    templateUrl: './frt-oto-bids-review.component.html',
    styleUrls: ['./frt-oto-bids-review.component.css'],
    standalone: false
})
export class FrtOtoBidsReviewComponent implements OnInit, OnDestroy {
  private observer$ = new BehaviorSubject(true);
  otoBidsGridOptions: GridOptions = this.initializeGridOptions();
  otoBidsList: any = [
  ];
  columnDefs: any;
  modalRef: BsModalRef;
  currentUser: any;
  isCarrierUser: boolean;
  isSysAdmin: boolean;
  isAgencyUser: boolean;


  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private modalService: BsModalService,
              private loader: LoadingService,
              private route: ActivatedRoute,
              public datePipe: DatePipe,
              private userService: UserService,
              private frtOtoRateQueryService: FrtOtoRateQueryService,
              private shipmentReviewService: ShipmentReviewService,
              private router: Router) {

  }

  checkUserRole() {
    // Get the current user.
    this.currentUser = this.userService.getUserDetails().subscribe(user => {
      this.currentUser = user;
      if (user && user.roles) {
        for (const role of user.roles) {
          if (role.name === carrier_user_admin || role.name === carrier_user) {
            this.isCarrierUser = true;
            break;
          } else if (role.name === system_admin) {
            this.isSysAdmin = true;
          } else if (role.name === agency_user || role.name === agency_admin_role || role.name === agency_auditor_role) {
            this.isAgencyUser = true;
          }
        }
      }
    });
  }


  getShipmentReviewColumnDefs(): (ColDef | ColGroupDef)[] {
    console.log('inside  method getShipmentReviewColumnDefs');
    return [
      <ColDef>
      {
        headerName: 'OTO Request ID',
        field: 'frtOtoRequestId',
        width: 100,
        filter: 'agTextColumnFilter',
        cellRenderer: params => {
          if (this.isSysAdmin || this.isAgencyUser) {
            return params.data.frtOtoRequestId;
          }
          return '<a tabindex="0">' + params.data.frtOtoRequestId + '</a>';
        },
        onCellClicked: event => {
          this.router.navigate(['/frtotobookshipment'], {
            queryParams: {frtOtoRequestId: event.data.frtOtoRequestId}
          });
        }
      },
      {
        headerName: 'Origin',
        field: 'originZipId',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination',
        field: 'tspPocEmail',
        filter: 'destinationZipId'
      },
      {
        headerName: 'Request Date/Time',
        field: 'requestDateTime',
        width: 180,
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Quote Date',
        field: 'quoteDateby',
        filter: 'agTextColumnFilter',
        width: 100
      },
      {
        headerName: 'Expedite Freight Shipment',
        field: 'expediteFreightShipment',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Pickup Date',
        field: 'pickupDate',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Pickup Time',
        field: 'pickupTime',
        width: 120,
        filter: 'agTextColumnFilter',
        valueFormatter: this.shipmentReviewService.formatNumber
      },
      {
        headerName: 'Delivery Date',
        width: 130,
        field: 'requiredDeliveryDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Delivery Time',
        width: 90,
        field: 'deliveryTime',
        filter: 'agTextColumnFilter'
      },

    ];
  }

  reviewBid(bidData: any) {
    let value = `
    <div class='container'>
    <div class="row"><b>Bid Requested By: </b>  ` + new Date(bidData.frtOtoRequestsEntity.requestDateTime) + `</div>
    <div class="row pt-2"><b>Pickup Date: </b>` + new Date(bidData.frtOtoRequestsEntity.pickupDate) + `</div>
    <div class="row pt-2"><b>Alternative Pickup Date: </b>` + new Date(bidData.alternatePickupDate) + `</div>
    <div class="row pt-2"><b>Delivery Date: </b>` + new Date(bidData.frtOtoRequestsEntity.requiredDeliveryDate) + `</div>
    <div class="row pt-2">
    <div class="col-md-6 padding-left-0">
    <div class="d-flex flex-row"><b>Origin:</b></div>
    <div class="d-flex flex-row pt-2"><b>Mileage: </b> ` + bidData.frtOtoRequestsEntity.estimatedMiles + `</div>
    <div class="d-flex flex-row pt-2"><b>Quoted Price: </b>` + bidData.quotedPrice + `</div>
    <div class="d-flex flex-row pt-2"><b>Shipment Declared Value: </b>` + bidData.frtOtoRequestsEntity.declaredShipmentValue + `</div>

    </div>
    <div class="col-md-6">
    <div class="d-flex flex-row"><b>Destination:</b></div>
    <div class="d-flex flex-row pt-2"><b>Weight: </b>` + bidData.frtOtoRequestsEntity.estimatedWeight + `</div>
    <div class="d-flex flex-row pt-2"><b>Quote Ref #: </b>` + bidData.quoteRefNum + `</div>
    </div>
    </div>
    <div class="row pt-2"><b>TSP POC Name: </b>` + bidData.tspPocName + `</div>
    <div class="row pt-2"><b>TSP POC Email: </b>` + bidData.tspPocEmail + `</div>
    <div class="row pt-2"><b>TSP POC Phone: </b>` + bidData.tspPocPhone + `</div>
    <div class="row pt-2"><b>Additional Questions: </b>` + bidData.additionalQuestions + `</div>
    </div>`;
    const config: ModalOptions = {
      class: 'modal-lg', // Add the Bootstrap large modal class
    };
    this.modalRef = this.modalService.show(ConfirmationModalComponent, config);
    this.modalRef.content.body = value;
    this.modalRef.content.title = 'Bid Review';
    this.modalRef.content.confirmText = 'Review & Accept';
    this.modalRef.content.cancelText = 'Cancel';
    this.modalRef.content.emitData.subscribe(res => {
      if (res.obj === true) {
        // this.callCreate(creatModal);
        this.loader.show();
        this.frtOtoRateQueryService.reviewBid(bidData)
          .pipe(takeWhile(() => this.observer$.value)).subscribe((response: any) => {
          this.getAllBids();
          this.loader.hide();
        }, (error) => {
          this.loader.hide();
          this.alertService.error("Error occurred while reviewing OTO bid. Please contact system administrator.")
        });
      }
      return;
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      rowHeight: 40,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  ngOnInit(): void {
    this.loader.show();
    this.checkUserRole();
    this.columnDefs = this.getShipmentReviewColumnDefs();
    this.getAllBids();
  }

  getAllBids() {
    this.frtOtoRateQueryService.getAllBids()
      .pipe(takeWhile(() => this.observer$.value)).subscribe((response: any) => {
      this.otoBidsList = response;
      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error("Error occurred while retrieving OTO bids. Please contact system administrator.")
    });
  }

  ngOnDestroy() {
    this.observer$.next(false);
  }
}
